import {SET_DIALOG } from '../constant'

export const platdialog = data =>({type:SET_DIALOG,data})